<template>
  <div class="school-label">
    <el-button
      size="mini"
      type="primary"
      @click="addSubject"
      icon="el-icon-plus"
      >添加视频</el-button
    >
    <div class="table-style">
      <el-table
        size="mini"
        :data="CouseList"
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column
          align="center"
          prop="sort_num"
          label="排序号"
          width="100"
        ></el-table-column>

        <el-table-column align="center" width="100" label="封面图">
          <template slot-scope="scope">
            <el-image
              style="width: 60px; height: 45px"
              :src="scope.row.cover_url"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="title"
          label="视频名称"
          width="200"
        ></el-table-column>

        <el-table-column align="center" label="课程类别" width="200">
          <template slot-scope="scope">
            <el-tag
              style="margin-left: 5px"
              size="mini"
              v-for="item of scope.row.videoTypeRelationArr"
              :key="item.if"
              type="info"
              >{{ item.videoTypeInfo.name }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="desc"
          label="介绍"
          width="200"
        ></el-table-column>

        <el-table-column align="center" label="所属科目" width="200">
          <template slot-scope="scope">
            <el-tag
              style="margin-left: 5px"
              size="mini"
              v-for="item of scope.row.videoSubjectArr"
              :key="item.id"
              >{{ item.subjectInfo.name }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="所属课程" width="200">
          <template slot-scope="scope">
            <el-tag
              style="margin-left: 5px"
              size="mini"
              v-for="item of scope.row.videoCurriculumArr"
              :key="item.id"
              >{{ item.curriculumInfo.title }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="所属角色" width="200">
          <template slot-scope="scope">
            <el-tag
              style="margin-left: 5px"
              size="mini"
              v-for="item of scope.row.videoAuthArr"
              :key="item.if"
              type="info"
              >{{ item.roleInfo.name }}</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="created_time"
          label="创建时间"
          width="200"
        ></el-table-column>

        <el-table-column
          align="center"
          prop="is_post"
          label="发布状态"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.is_post">已发布</span>
            <span v-else>未发布</span>
          </template>
        </el-table-column>

        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-link
              style="margin-left: 10px"
              @click="updateTag(scope.row)"
              type="primary"
              >修改</el-link
            >
            <el-link
              style="margin-left: 10px"
              @click="deleteTag(scope.row)"
              type="primary"
              >删除</el-link
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-style">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page_no"
          layout="total, prev, pager, next"
          :total="total"
          :page-size="20"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="新增课程" :visible.sync="dialogVisible">
      <el-form
        class="form-style"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
        label-position="left"
      >
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number
            v-model="form.sort_num"
            :precision="0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="类型" required>
          <el-select
            style="width: 400px"
            v-model="form.videoTypeIds"
            multiple
            placeholder="请选择"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of videoList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="名称" required prop="name">
          <el-input
            placeholder="请输入课程名称"
            v-model="form.name"
            style="width: 400px"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="封面图" required prop="cover">
          <el-input
            placeholder="请输入封面图地址"
            v-model="form.cover"
            style="width: 400px"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="描述" required prop="desc">
          <el-input
            placeholder="请输入课程描述"
            v-model="form.desc"
            style="width: 400px"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="授课类型" prop="teaching_type" required>
          <el-select
            clearable
            v-model="form.teaching_type"
            placeholder="请选择"
            style="width: 400px"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of teaching_type"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否公开">
          <!-- `checked` 为 true 或 false -->
          <el-checkbox v-model="form.is_open">设为公开</el-checkbox>
        </el-form-item>

        <el-form-item label="所属科目">
          <el-select
            multiple
            clearable
            v-model="form.subjectIds"
            placeholder="请选择科目"
            style="width: 400px"
            filterable
            @change="getCurriculumList"
            :disabled="form.is_open"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) of subjectList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程体系">
          <el-select
            multiple
            clearable
            :disabled="form.subjectIds.length == 0 || form.is_open"
            v-model="form.curriculumIds"
            placeholder="请选择课程体系"
            style="width: 400px"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) of curriculum_list"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="角色">
          <el-select
            style="width: 400px"
            v-model="form.roleIds"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in RoleData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog('form')">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEducationalInstitutionList,
  getVideoTypeList,
  adminDeleteVideo,
  getSubjectList,
  adminGetRoleList,
  adminCreateOrUpdateVideo,
  adminGetVideoList,
  adminUpdateVideoPostState,
} from "@/api/admin.js";
import { getCurriculumList } from "@/api/educational";
export default {
  name: "courselist",
  data() {
    return {
      educational_institution_list: [],
      total: 0,
      page_no: 1,
      page_size: 20,
      tagId: "",
      form: {
        video_id: "",
        name: "",
        sort_num: 1,
        desc: "",
        curriculum_id: "",
        videoTypeIds: [],
        roleIds: [],
        url: "",
        cover: "",
        teaching_type: 1,
        subjectIds: [], //科目列表
        curriculumIds: [], // 体系列表
        is_open: false,
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入标题",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],

        cover: [
          {
            required: true,
            message: "请输入封面图地址",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入封面图地址",
            trigger: "blur",
          },
        ],

        url: [
          {
            required: true,
            message: "请输入压缩包地址",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入压缩包地址",
            trigger: "blur",
          },
        ],

        desc: [
          {
            required: true,
            message: "请输入课程介绍",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入课程介绍",
            trigger: "blur",
          },
        ],
      },

      teaching_type: [
        { name: "面授课", id: 1 },
        { name: "直播课", id: 2 },
        { name: "录播课", id: 3 },
      ],

      schoolTagList: [],
      videoList: [],
      subjectList: [],
      curriculum_list: [], //课程体系类表
      RoleData: [], //角色列表
      CouseList: [],
    };
  },

  watch: {
    "form.is_open": function () {
      if (this.form.is_open) {
        this.form.subjectIds = [];
        this.form.curriculumIds = [];
      }
    },
  },

  mounted() {
    this.getVideoTypeList(); //获得平台视频分类
    this.getSubjectList(); //获得平台科目
    this.adminGetRoleList();
    this.adminGetVideoList();
  },
  methods: {
    // 获取课程体系
    getCurriculumList() {
      console.log("查询课程体系");
      console.log(this.form.subjectIds);
      console.log(this.form.teaching_type);

      this.curriculum_list = [];

      for (let k = 0; k < this.form.subjectIds.length; k++) {
        getCurriculumList(
          {
            subject_id: this.form.subjectIds[k],
            teaching_type: this.form.teaching_type,
            page_no: 1,
            page_size: 200,
          },
          true
        ).then((res) => {
          console.log("课程体系数据");
          console.log(res);
          this.curriculum_list = this.curriculum_list.concat(
            res.curriculum_list
          );
        });
      }
    },

    //获得平台科目
    getSubjectList() {
      getSubjectList({ subject_state: 1, page_size: 200 }, true).then((res) => {
        this.subjectList = res.subject_list;
      });
    },

    //获得平台角色
    adminGetRoleList() {
      adminGetRoleList().then((res) => {
        console.log("查询角色列表");
        console.log(res);
        this.RoleData = res.role_list;
      });
    },

    // 获取合作学校列表
    getEducationalInstitutionList(query) {
      getEducationalInstitutionList({
        educational_institution_name: query,
        page_size: 200,
      }).then((res) => {
        this.educational_institution_list = res.educational_institution_list;
      });
    },

    getVideoTypeList() {
      getVideoTypeList().then((res) => {
        console.log("查询视频分类列表");
        console.log(res);
        this.videoList = res.videoList;
      });
    },

    //获得视频类表

    adminGetVideoList() {
      adminGetVideoList({
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("查询视频课程列表");
        console.log(res);
        this.CouseList = res.videoList;
        this.total = res.total;
      });
    },

    handleCurrentChange(val) {
      this.page_no = val;
      this.adminGetVideoList();
    },
    addSubject() {
      this.dialogVisible = true;
      this.tagId = "";

      this.form.subject_name = "";
      this.form.sort_num = 1;
      this.form.educational_institution_id = "";
      this.form.color = "";

      this.form.videoTypeIds = [];
      this.form.name = "";
      this.form.desc = "";
      this.form.cover = "";
      this.form.url = "";
      this.form.roleIds = [];
      this.form.subjectIds = [];
      this.form.curriculumIds = [];
    },
    quitDialog(formName) {
      this.tagId = "";
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    updateTag(row) {
      console.log("更新培训视频");
      console.log(row);

      this.tagId = row.id;
      this.form.sort_num = row.sort_num;

      this.form.videoTypeIds = [];
      for (let k = 0; k < row.videoTypeRelationArr.length; k++) {
        this.form.videoTypeIds.push(
          row.videoTypeRelationArr[k].videoTypeInfo.id
        );
      }

      this.form.subjectIds = [];
      for (let k = 0; k < row.videoSubjectArr.length; k++) {
        this.form.subjectIds.push(row.videoSubjectArr[k].subjectInfo.id);
      }

      this.form.curriculumIds = [];
      for (let k = 0; k < row.videoCurriculumArr.length; k++) {
        this.form.curriculumIds.push(
          row.videoCurriculumArr[k].curriculumInfo.id
        );
      }

      this.form.cover = row.cover_url;
      this.form.url = row.url;
      this.form.desc = row.desc;
      this.form.name = row.title;
      this.form.teaching_type = row.teaching_type;
      this.form.is_open = row.common;
      this.form.subject_id = row.subject_id;
      this.form.curriculum_id = row.curriculum_id;

      this.form.roleIds = [];
      for (let k = 0; k < row.videoAuthArr.length; k++) {
        this.form.roleIds.push(row.videoAuthArr[k].role_id);
      }

      this.dialogVisible = true;
      this.getCurriculumList();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.tagId) {
            console.log("更新视频信息");

            adminCreateOrUpdateVideo(
              {
                video_id: this.tagId,
                sort_num: this.form.sort_num,
                title: this.form.name,
                teaching_type: this.form.teaching_type,
                common: this.form.is_open,
                subjectIds:
                  this.form.subjectIds.length == 0
                    ? null
                    : JSON.stringify(this.form.subjectIds),
                curriculumIds:
                  this.form.curriculumIds.length == 0
                    ? null
                    : JSON.stringify(this.form.curriculumIds),
                desc: this.form.desc,
                cover_url: this.form.cover,
                roleIds: JSON.stringify(this.form.roleIds),
                videoTypeIds: JSON.stringify(this.form.videoTypeIds),
              },
              true
            ).then(() => {
              this.$message.success("修改视频分类成功！");
              this.dialogVisible = false;
              this.adminGetVideoList();
            });
          } else {
            console.log("新增视频");
            console.log(this.form);

            adminCreateOrUpdateVideo(
              {
                sort_num: this.form.sort_num,
                title: this.form.name,
                teaching_type: this.form.teaching_type,
                common: this.form.is_open,
                subjectIds:
                  this.form.subjectIds.length == 0
                    ? null
                    : JSON.stringify(this.form.subjectIds),
                curriculumIds:
                  this.form.curriculumIds.length == 0
                    ? null
                    : JSON.stringify(this.form.curriculumIds),
                desc: this.form.desc,
                cover_url: this.form.cover,
                roleIds: JSON.stringify(this.form.roleIds),
                videoTypeIds: JSON.stringify(this.form.videoTypeIds),
              },
              true
            ).then(() => {
              this.$message.success("添加视频成功！");
              this.dialogVisible = false;
              this.adminGetVideoList();
            });
          }
        }
      });
    },

    deleteTag(row) {
      adminDeleteVideo(
        {
          video_id: row.id,
        },
        true
      ).then(() => {
        this.$message.success("删除成功！");
        this.adminGetVideoList();
      });
    },

    //发布视频
    Publish(row) {
      console.log("发布视频");
      console.log(row);

      adminUpdateVideoPostState({
        video_id: row.id,
        is_post: true,
      }).then((res) => {
        console.log("发布视频");
        console.log(res);
        if (res.is_update) {
          this.$message.success("发布成功");
          this.adminGetVideoList();
        }
      });
    },
    //取消发布
    CancelPublish(row) {
      console.log("取消发布视频");
      console.log(row);

      adminUpdateVideoPostState({
        video_id: row.id,
        is_post: false,
      }).then((res) => {
        console.log("取消发布视频");
        console.log(res);
        if (res.is_update) {
          this.$message.success("取消发布");
          this.adminGetVideoList();
        }
      });
    },

    FileList() {
      console.log("文件管理");
    },
  },
};
</script>

<style scoped lang="scss">
.school-label {
  height: 100%;
  background-color: #fff;
  padding: 15px;
  margin: 15px;
  border-radius: 5px;
  .form-style {
    margin-left: 15px;
  }
  .table-style {
    margin-top: 20px;
  }
}
</style>
